import { makeRequest } from 'utils/requestLogger';

export default (profileID, submissionID) =>
  makeRequest('put', `/api/submissions/${submissionID}/toggle-seen-by`);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/submission/markSubmissionAsRead.js